import { RadioGroup } from "@headlessui/react";

interface ISizeSelector {
  value: string;
  onChange: (value: any) => void;
  options: { value: string; label: string }[];
}

function SizeSelector({ value, onChange, options }: ISizeSelector) {
  return (
    <RadioGroup value={value} onChange={onChange}>
      <div className="flex space-x-2">
        {options.map((option) => (
          <RadioGroup.Option
            key={option.value}
            value={option.value}
            className={({ checked }) =>
              `w-20 cursor-pointer rounded-md px-3 py-1 text-center text-sm font-medium ${
                checked
                  ? "bg-orange-500 text-white dark:bg-orange-600"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
              }`
            }
          >
            {option.label}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  );
}

export default SizeSelector;
